import { render, staticRenderFns } from "./add-template-popup.vue?vue&type=template&id=2ab46cbd"
import script from "./add-template-popup.vue?vue&type=script&lang=js"
export * from "./add-template-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports